export default {
  common: {
    systemTitle: 'BADAM管理系统',
    confirm: '确定',
    cancel: '取消',
    add: '添加',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    search: '搜索',
    reset: '重置',
    back: '返回',
    loading: '加载中...',
    noData: '暂无数据',
    operation: '操作',
    success: '成功',
    failed: '失败',
    export: '导出',
    import: '导入',
    view: '查看',
    close: '关闭'
  },
  
  auth: {
    systemTitle: 'BADAM管理系统',
    loginSubtitle: '欢迎登录',
    username: '用户名',
    password: '密码',
    login: '登录',
    logout: '退出登录',
    loggingIn: '登录中...',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '已退出登录',
    logoutConfirm: '确认退出登录吗？',
    usernameRequired: '请输入用户名',
    passwordRequired: '请输入密码',
    captcha: '验证码',
    captchaRequired: '请输入验证码',
    captchaPlaceholder: '请输入图中验证码',
    refreshCaptcha: '换一张',
    defaultAccount: '默认账号',
    initSystem: '初始化系统'
  },
  
  project: {
    title: '收购管理',
    name: '项目名称',
    description: '项目描述',
    createTime: '创建时间',
    createProject: '创建项目',
    editProject: '编辑项目',
    deleteProject: '删除项目',
    enterProject: '进入项目',
    projectList: '项目列表',
    projectDetail: '项目详情',
    backToList: '返回项目列表',
    deleteConfirm: '确认删除该项目吗？删除后该项目下的所有数据都将被删除！',
    purchaseModule: '收购管理',
    shipmentModule: '发货管理',
    selectModule: '请选择要进入的模块'
  },
  
  customer: {
    title: '客户管理',
    customerNumber: '客户编号',
    price: '单价(元/斤)',
    tareWeight: '去皮重量(斤)',
    createTime: '创建时间',
    addCustomer: '添加客户',
    editCustomer: '编辑客户',
    deleteCustomer: '删除客户',
    customerList: '客户列表',
    deleteConfirm: '确认删除该客户吗？删除后该客户的所有过称记录也将被删除！',
    pricePerJin: '元/斤',
    jinPerBasket: '斤/筐',
    recalculate: '重算',
    recalculateConfirm: '确认重新计算客户 {customerNumber} 的所有过称记录吗？',
    editWarning: '修改客户价格或皮重将重新计算该客户的所有历史过称记录，确认继续吗？',
    recalculateSuccess: '重新计算完成',
    noRecords: '点击添加第一条过称记录',
    purchaseManagement: '收购管理'
  },
  
  record: {
    title: '过称记录',
    totalWeight: '总重量(斤)',
    basketCount: '筐子数量',
    tareWeight: '皮重(斤)',
    netWeight: '净重(斤)',
    totalAmount: '金额(元)',
    weighTime: '过称时间',
    remark: '备注',
    addRecord: '添加过称记录',
    editRecord: '编辑过称记录',
    deleteRecord: '删除记录',
    deleteConfirm: '确认删除该记录吗？',
    weigh: '过称',
    recordList: '过称记录',
    recordsByDate: '过称记录（按时间倒序）',
    currentStats: '当前统计'
  },
  
  shipment: {
    title: '发货记录',
    licensePlate: '车牌号码',
    driverPhone: '司机电话',
    driverName: '司机姓名',
    receiverPhone: '收货人电话',
    totalWeight: '货物重量(公斤)',
    basketCount: '筐子数量',
    freightCost: '运费',
    basketCost: '筐子费用',
    waxingCost: '打蜡费用',
    agencyCost: '代办费用',
    otherCost: '其他费用',
    totalCost: '总成本',
    costInfo: '成本信息',
    shipmentTime: '发货时间',
    destination: '目的地',
    remark: '备注',
    addShipment: '添加发货记录',
    editShipment: '编辑发货记录',
    deleteShipment: '删除发货记录',
    deleteConfirm: '确认删除该发货记录吗？',
    shipmentList: '发货记录列表',
    shipmentManagement: '发货管理',
    viewShipments: '查看发货记录',
    cargoInfo: '货物信息',
    cargoName: '货物名称',
    driverInfo: '司机信息',
    receiverInfo: '收货人信息',
    print: '打印',
    printPreview: '打印预览',
    shipmentReceipt: '发货单',
    printDate: '打印日期',
    sender: '发货人',
    receiver: '收货人',
    kg: '公斤'
  },
  
  cost: {
    costManagement: '成本管理',
    basketCost: '筐子费用',
    waxingCost: '打蜡费用',
    agencyCost: '代办费用',
    otherCost: '其他费用',
    totalCost: '总成本',
    costDetails: '成本明细',
    remark: '备注',
    editCost: '编辑成本',
    noCostRecord: '该发货记录还没有成本记录',
    deleteConfirm: '确认删除该成本记录吗？',
    batchDelete: '批量删除',
    batchDeleteConfirm: '确认移除选中的 {count} 条发货记录吗？对应成本会一起去掉，列表里不再显示。',
    selectCostFirst: '请先选择要删除的记录',
    hideConfirm: '确认移除这条发货记录吗？对应成本会一起去掉，列表里不再显示。'
  },
  
  statistics: {
    title: '统计报表',
    viewStatistics: '查看统计',
    totalRecords: '总记录数',
    totalBaskets: '总筐数',
    totalTareWeight: '总皮重',
    totalNetWeight: '总净重',
    totalGrossWeight: '总毛重',
    totalAmount: '总金额',
    averagePrice: '平均价格',
    averageWeight: '平均每次净重',
    actualAveragePrice: '实际均价',
    customerCount: '客户数量',
    customerDetails: '客户统计详情',
    customerDetailsByDate: '客户统计详情（按创建时间倒序）',
    recordCount: '记录次数',
    firstWeighTime: '首次过称',
    lastWeighTime: '最后过称',
    setPrice: '设定价格',
    projectAvgPrice: '项目均价',
    times: '次',
    baskets: '个',
    jin: '斤',
    yuan: '元',
    people: '人'
  },
  
  report: {
    title: '数据报表',
    dataReport: '数据报表',
    dataAnalysis: '数据报表分析',
    dateRange: '日期范围',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    generateReport: '生成报表',
    exportExcel: '导出Excel',
    exporting: '导出中...',
    selectDateRange: '请选择日期范围',
    useDefaultRange: '使用默认日期范围',
    dailyTrend: '每日数据趋势',
    customerAmountRatio: '客户金额占比',
    customerComparison: '客户对比分析',
    topByAmount: '金额最高',
    topByWeight: '重量最高',
    topByRecords: '记录最多',
    highestPrice: '价格最高',
    lowestPrice: '价格最低',
    customerDetailData: '客户详细数据',
    dailyStatistics: '每日统计数据',
    date: '日期',
    amount: '金额',
    weight: '重量',
    netWeight: '净重',
    grossWeight: '毛重',
    dailyAvgPrice: '当日均价',
    overallStats: '总体统计',
    reportGenerated: '报表生成成功',
    reportFailed: '报表生成失败',
    exportSuccess: 'Excel导出成功',
    exportFailed: 'Excel导出失败',
    noDataPrompt: '请选择日期范围并生成报表'
  },
  
  message: {
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    loadFailed: '加载失败',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    pleaseSelectDateRange: '请选择日期范围',
    pleaseGenerateReport: '请先生成报表数据',
    confirmDelete: '确认删除',
    warning: '警告',
    info: '提示',
    required: '必填项',
    pleaseInput: '请输入',
    pleaseSelect: '请选择'
  }
}
